"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseButton = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var CloseButton = _styledComponents.default.button.attrs({
  type: 'button'
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background: #ffc033;\n  border-radius: 100%;\n  border: none;\n  outline: none;\n  color: white;\n  display: flex;\n  padding: 0;\n  justify-content: center;\n  align-items: center;\n  font-weight: bold;\n  line-height: 0;\n  position: absolute;\n  width: 25px;\n  height: 25px;\n  top: ", ";\n  right: ", ";\n  font-size: 20px;\n  cursor: pointer;\n  z-index: 999999999;\n  ", ";\n  &:before {\n    content: '\xD7';\n    margin-top: 2px;\n  }\n  &:active {\n    background: #b48526;\n  }\n  &:active,\n  :focus {\n    outline: 0;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n  }\n  ", "\n"])), function (_ref) {
  var top = _ref.top;
  return top || '20px';
}, function (_ref2) {
  var right = _ref2.right;
  return right || '30px';
}, function (_ref3) {
  var $bsStyle = _ref3.$bsStyle;
  return $bsStyle || '';
}, function (_ref4) {
  var $bsStyle = _ref4.$bsStyle;
  return $bsStyle || '';
});
exports.CloseButton = CloseButton;